<template>
  <div id="page">
    <h1 class="h1">我的算法别名</h1>
    <a-table
      :data-source="names"
      :columns="namesCols"
      :pagination="false"
      style="margin-bottom: 1rem"
      size="middle"
    >
      <span slot="add_time" slot-scope="text">{{
        text.replace("T", "，")
      }}</span>
      <a-popconfirm
        title="是否确认删除？"
        ok-text="是"
        cancel-text="否"
        @confirm="deleteName(index)"
        slot="action"
        slot-scope="text, record, index"
      >
        <a-button type="danger" size="small">删除</a-button>
      </a-popconfirm>
    </a-table>

    <template v-if="isAddName">
      <a-input
        placeholder="iid"
        style="width: 12rem; margin-right: 1.5rem"
        v-model="iidToAdd"
      ></a-input>
      <a-input
        placeholder="api调用时的实例名称"
        style="width: 12rem; margin-right: 1.5rem"
        v-model="nameToAdd"
      ></a-input>
      <a-button type="primary" style="margin-right: 1rem" @click="addName"
        >确认</a-button
      >
      <a-button type="primary" @click="changeAddName">取消</a-button>
    </template>
    <a-button v-if="!isAddName" type="primary" @click="changeAddName"
      >添加别名</a-button
    >

    <h1 class="h1" style="margin-top: 3rem">我的应用</h1>
    <a-table
      :data-source="tokens"
      :columns="tokensCols"
      :pagination="false"
      style="margin-bottom: 1rem"
      size="middle"
    >
      <span slot="add_time" slot-scope="text">{{
        text.replace("T", "，")
      }}</span>

      <a-popconfirm
        title="是否确认删除？"
        ok-text="是"
        cancel-text="否"
        @confirm="deletetoken(index)"
        slot="action"
        slot-scope="text, record, index"
      >
        <a-button type="danger" size="small">删除</a-button>
      </a-popconfirm>
    </a-table>
    <a-button type="primary" v-if="!isAddToken" @click="changeAddToken"
      >添加应用</a-button
    >
    <template v-if="isAddToken">
      <a-input
        placeholder="应用名称"
        style="width: 12rem; margin-right: 1.5rem"
        v-model="tokenToAdd"
      ></a-input>
      <a-button type="primary" style="margin-right: 1rem" @click="addToken"
        >确认</a-button
      >
      <a-button type="primary" @click="changeAddToken">取消</a-button>
    </template>
  </div>
</template>

<script>
const namesCols = [
  { title: 'iid', dataIndex: 'instance_id', key: 'instance_id' },
  { title: '名称', dataIndex: 'api', key: 'api' },
  {
    title: '创建时间',
    dataIndex: 'add_time',
    key: 'add_time',
    scopedSlots: { customRender: 'add_time' }
  },
  {
    title: '操作',
    dataIndex: '',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]
const tokensCols = [
  { title: '名称', dataIndex: 'token_name', key: 'token_name' },
  { title: 'access_token', dataIndex: 'token', key: 'token' },
  {
    title: '创建时间',
    dataIndex: 'add_time',
    key: 'add_time',
    scopedSlots: { customRender: 'add_time' }
  },
  {
    title: '操作',
    dataIndex: '',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  data() {
    return {
      namesCols,
      tokensCols,
      names: [],
      isAddName: false,
      nameToAdd: '',
      iidToAdd: '',
      tokenToAdd: '',
      isAddToken: false,
      tokens: []
    }
  },
  methods: {
    changeAddName() {
      this.isAddName = !this.isAddName
    },
    async addName() {
      const resp = await this.$http.post('/api/bind', {
        instance_id: this.iidToAdd,
        relative_url: this.nameToAdd
      })

      if (resp.data.data) {
        this.names.push(resp.data.data)
        this.isAddName = false
      }
    },
    async addToken() {
      const resp = await this.$http.post('/ak/' + this.tokenToAdd)

      if (resp.data.data) {
        this.tokens.push(resp.data.data)
        this.isAddToken = false
      }
    },
    async deleteName(index) {
      await this.$http.delete(`/api/${this.names[index].id}`)
      this.names.splice(index, 1)
    },
    changeAddToken() {
      this.isAddToken = !this.isAddToken
    },
    async deletetoken(index) {
      await this.$http.delete(`/ak/${this.tokens[index].id}`)
      this.tokens.splice(index, 1)
    }
  },
  async mounted() {
    let resp = await this.$http.get('/apis')
    this.names = resp.data
    resp = await this.$http.get('/my_aks')
    this.tokens = resp.data
  }
}
</script>

<style lang="less" scoped>

.h1 {
  font-size: 1.4rem;
  font-weight: bold;
}
</style>
